import { render } from "./FullScreenModal.vue?vue&type=template&id=72005818&scoped=true"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"

import "./FullScreenModal.vue?vue&type=style&index=0&id=72005818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72005818"]])

export default __exports__